import { contactDetails, socialMediaUrl } from "../Details";
import { useRef, useEffect } from "react";
import gsap from "gsap";

function Contact() {
  const { email, phone } = contactDetails;
  const { linkedin, github, portfolio } = socialMediaUrl;
  const h11 = useRef();
  const h12 = useRef();

  useEffect(() => {
    const tl = gsap.timeline();
    tl.from(h11.current, { x: "-100%", delay: 0.2, opacity: 0, duration: 2, ease: "Power3.easeOut" }, "<")
      .from(h12.current, { x: "200%", delay: 0.0, opacity: 0, duration: 2, ease: "Power3.easeOut" }, "<");
  }, []);

  return (
    <main className="max-width section flex flex-col items-center">
      <h3 ref={h11} className="text-center text-xl md:text-2xl lg:text-3xl text-gradient font-bold pb-6">
        <a href={`mailto:${email}`}>{email}</a>
      </h3>
      <span className="text-gradient text-6xl font-light">||</span>
      <h3 ref={h12} className="text-center text-xl md:text-2xl lg:text-3xl text-gradient font-bold pt-6">
        <a href={`tel:${phone}`}>{phone}</a>
      </h3>
      <div className="flex flex-wrap justify-center gap-4 pt-10 text-content font-medium">
        <a href={linkedin} target="_blank" rel="noreferrer noopener" className="hover:underline">LinkedIn</a>
        <span>|</span>
        <a href={github} target="_blank" rel="noreferrer noopener" className="hover:underline">GitHub</a>
        {portfolio && (
          <>
            <span>|</span>
            <a href={portfolio} target="_blank" rel="noreferrer noopener" className="hover:underline">Portfolio</a>
          </>
        )}
      </div>
    </main>
  );
}

export default Contact;
